import type { ReminderSource } from '@renderer/overlay/Sidepanel/hooks/use-reminders'

export function getSourceFallback(type: ReminderSource['type']): string {
  switch (type) {
    case 'audioNote':
      return 'Audio Note'
    case 'dailySummary':
      return 'Daily Summary'
    case 'insight':
      return 'Insight'
    case 'conversation':
      return 'Chat'
    case 'screen':
      return 'Screen'
    default:
      return 'Highlight'
  }
}

export function getSourceLabel(source: ReminderSource): string {
  return source?.title || getSourceFallback(source.type)
}
